import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    site: argus_url.site,
    lang: 'de',
  },
  mutations: {
    setLang(state, lang) {
      state.lang = lang
    },
  },
})
